<app-equipment-admin></app-equipment-admin>
